<template>
  <div id="basic-info">
    <h4 class="sub-title">Basic Information</h4>
    <div class="firstName mt-4">
      <label for="firstName">First Name:</label>
      <b-form-input
        name="first_name"
        type="text"
        id="first_name"
        v-model="first_name"
        :state="firstNameInput"
      ></b-form-input>
    </div>
    <div class="middleName mt-4">
      <label for="middleName">Middle Name:</label>
      <b-form-input
        name="middle_name"
        type="text"
        id="middle_name"
        v-model="middle_name"
      ></b-form-input>
    </div>
    <div class="lastName mt-4">
      <label for="lastName">Last Name:</label>
      <b-form-input
        name="last_name"
        type="text"
        id="last_name"
        v-model="last_name"
        :state="lastNameInput"
      ></b-form-input>
    </div>
    <div class="dob mt-4">
      <label class="left" for="dob">Date of Birth:</label>
      <b-form-input
        name="dob"
        type="date"
        id="dob"
        v-model="dob"
      ></b-form-input>
    </div>
    <div class="sex mt-4">
      <label for="sex">Sex:</label>
      <br />
      <b-form-select
        name="sex"
        type="text"
        id="sex"
        v-model="sex"
        :state="sexInput"
      >
        <option disabled value>Select a Sex</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
      </b-form-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicInfo',
  props: {
    singular: String,
    plural: String,
  },
  computed: {
    first_name: {
      get() {
        return this.$store.state[this.plural][this.singular].first_name;
        console.log(this.$store.state[this.plural][this.singular].first_name);
      },
      set(val) {
        this.$store.commit(`${this.plural}/first_name`, val);
      },
    },
    middle_name: {
      get() {
        return this.$store.state[this.plural][this.singular].middle_name;
      },
      set(val) {
        this.$store.commit(`${this.plural}/middle_name`, val);
      },
    },
    last_name: {
      get() {
        return this.$store.state[this.plural][this.singular].last_name;
      },
      set(val) {
        this.$store.commit(`${this.plural}/last_name`, val);
      },
    },
    dob: {
      get() {
        return this.$store.state[this.plural][this.singular].dob;
      },
      set(val) {
        this.$store.commit(`${this.plural}/dob`, val);
      },
    },
    sex: {
      get() {
        return this.$store.state[this.plural][this.singular].sex;
      },
      set(val) {
        this.$store.commit(`${this.plural}/sex`, val);
      },
    },
    firstNameInput() {
      return (
        this.$store.state[this.plural][this.singular].first_name.length > 2
      );
    },
    lastNameInput() {
      return this.$store.state[this.plural][this.singular].last_name.length > 2;
    },
    sexInput() {
      return this.$store.state[this.plural][this.singular].sex.length > 2;
    },
  },
};
</script>
